import { useForm } from "react-hook-form";
import { CadastrarCategoriasRespostaChatController } from "../../../../Controllers/HelpDesk/GestaoRespostas/GestaoRespostasControllers";

import { ICategorias } from "../../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";

interface ICadastrarRespostaChatProps {
    updateList: () => void;
    setShow: (show: boolean) => void;
}

export default function CadastrarCategoriasRespostaChat(
    props: ICadastrarRespostaChatProps
) {
    const { register, handleSubmit, formState, reset } = useForm<ICategorias>();

    const onSubmit = (formData: ICategorias) => {
        CadastrarCategoriasRespostaChatController(formData).then((res) => {
            props.setShow(false);
            reset();
            props.updateList();
        });
    };

    return (
        <>
            <div className="text-center mb-10">
                <h2 className="font-weight-bold">Cadastro de Categoria</h2>
                <p className="text-muted font-weight-bold">
                    Entre com o nome da categoria
                </p>
            </div>
            <form
                className="form"
                id="kt_login_signin_form"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="form-group border-bottom py-3 b-5">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_CATEGORIA_RESPOSTA_CHAT &&
                            "is-invalid"
                        }`}
                        type="text"
                        placeholder="Nome da Categoria"
                        name="DS_CATEGORIA_RESPOSTA_CHAT"
                        ref={register({
                            required: "Insira o nome da Categoria",
                        })}
                        autoComplete="off"
                    />
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="submit"
                        id="kt_login_signin_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Cadastrar
                    </button>
                </div>
            </form>
        </>
    );
}
